// Utility functions for backend API communication

/**
 * Creates a request object for the backend API
 * @param {Object} payload - The request payload
 * @param {string} userId - The user ID
 * @returns {Object} Request object with header and payload
 */
export const createBackendRequest = (payload, userId) => ({
  Header: {
    Id: generateGuid(),
    Application: "03FC0B90-DFAD-11EE-8D86-0800200C9A66",
    Bank: "NBG",
    UserId: userId || "00000000-0000-0000-0000-000000000000",
  },
  Payload: payload,
});

/**
 * Generates a GUID
 * @returns {string} A new GUID
 */
const generateGuid = () => {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
    const r = (Math.random() * 16) | 0;
    const v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
};

/**
 * Extract user ID from state or token
 * @param {Object} state - Application state
 * @returns {string} User ID
 */
export const getUserIdFromState = (state) => {
  // Try to get user ID from state - check multiple possible locations
  const userId =
    state?.applicationUser?.get?.("userId") ||
    state?.applicationUser?.userId ||
    state?.applicationUser?.uid ||
    state?.applicationUser?.uuid ||
    state?.user?.id;

  return userId || "00000000-0000-0000-0000-000000000000";
};
